import antdSA from 'antd/lib/locale-provider/it_IT';
import * as appLocaleData  from  'react-intl/locale-data/it';
import saMessages from '../locales/it_IT';

const saLang = {
    messages: {
        ...saMessages
    },
    antd: antdSA,
    locale: 'it-IT',
    data: appLocaleData
};
export default saLang;



// WEBPACK FOOTER //
// ./src/languageProvider/entries/it_IT.ts